<template>
    <div class="page">

        <z-add-entity ref="addEntityModel" @success="refreshTable"></z-add-entity>
        <z-upload-entity ref="uploadEntityModel" @success="refreshTable"></z-upload-entity>
        <z-update-group ref="updateGroupModel" @success="refreshTable"></z-update-group>
        <z-entity-detail ref="entityDetailModel" :titles="titles"></z-entity-detail>
        <z-update-entity ref="updateEntityModel" @success="refreshTable"></z-update-entity>
        <z-device-bind ref="deviceBindModel" @success="refreshTable"></z-device-bind>
        <ZPersonalConfig ref="personalConfigModal" />
        <ZPersonalConfigOf ref="personalConfigOfModal" />
        <ZPersonalConfigAy ref="personalConfigAyModal" />
        <ZPersonalConfigZ32S ref="personalConfigZ32SModal" />
        <ZPersonalFence ref="personalFenceModal" />
        <ZPersonalTrack ref="personalTrackModal" />
        <ZAskLeave
                ref="showAskLeave"
            v-if="showAskLeaveModal"
            :showAskLeaveModal="showAskLeaveModal"
            @quit="closeAskLeaveModal"
                @success="refreshTable"
            :entityInfo="entityInfo"
        />

        <!-- <FenceDrawer /> -->
        <a-row  :gutter="0">
            <a-col span="24">
                <a-row class="content" style="width: 33%">
                    <a-col span="6">
                        <label>{{$t('global.org')}}:</label>
                    </a-col>
                    <a-col span="18">
                        <z-org-chooser :option="orgOption" @orgSelect="onOrgSelect" @directChange="onDirectChange"></z-org-chooser>
                    </a-col>
                </a-row>

                <div>
                    <a-row class="content" v-if="groups.length > 0">
                        <a-col :md="{span:6}" :lg="{span:6}"  v-for="group in groups" :key="group.id">
                            <div style="margin:20px;">
                                <a-card @click="filterByGroup" :style="group.groupId == org.defaultEntityGroupId ? {'background-color':'#e6f7ff', 'cursor': 'pointer'} : {'cursor': 'pointer'}">
                                    <a-card-meta :description="group.groupDescription">
                                        <div class="avatar-icon" slot="avatar" >
                                          <i class="icon-custom icon-online">
                                            <zx-icon type="icon-renyuanfenzuguanli"></zx-icon>
                                          </i>
                                        </div>
                                        <div slot="title">
                                            {{group.groupName}}
                                            <span class="subText" v-if="roles === 'Org' && group.aliasName"> - 
                                                {{group.aliasName}}
                                            </span>
                                            ({{group.entityNum}})
                                        </div>
                                    </a-card-meta>

                                    <a-row>
                                        <a-col span="21">
                                            <a-progress strokeLinecap="square" :showInfo="false"  :percent="group.percent" />
                                        </a-col>
                                        <a-col span="2" offset="1">
                                            <span>{{group.percent + '%'}}</span>
                                        </a-col>
                                    </a-row>
                                </a-card>
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </a-col>
            <a-col span="24">
                <z-search-form v-if="searchOption.length > 0" :searchOption="searchOption" @search="handleSearch"></z-search-form>

                <div class='section-list content'>
                    <div style="margin: 0 0 10px 15px">
                        <a-row type="flex" justify="start" :gutter="8">
                            <a-col>
                                <a-button size="small" @click="showAddEntity" type="primary">
                                    <a-icon type="plus"/>
                                    {{$t('global.create')}}
                                </a-button>
                            </a-col>
                            <a-col>
                                <a-button size="small" @click="showUploadEntity">
                                    <a-icon type="upload" style="padding-right:4px"/>
                                    {{$t('global.import')}}
                                </a-button>
                            </a-col>
                            <a-col>
                                <a-button size="small" >
                                    <a-icon type="download" style="padding-right:4px"/>
                                    <a :href="`/api/entity/v1.0/export?Authorization=Bearer ${token}`">{{$t('global.export')}}</a>
                                </a-button>
                            </a-col>
                            <a-col v-if="selectedRowKeys.length">
                                <a-dropdown>
                                    <a-menu slot="overlay" @click="handleMenuClick">
                                        <a-menu-item key="1"  @click="batchDelete">{{$t('global.delete')}}</a-menu-item>
                                        <a-menu-item key="2"  @click="batchUpdateGroup">{{$t('global.changeBelong')}}</a-menu-item>
                                    </a-menu>
                                    <a-button  size="small">
                                        {{$t('global.moreOperation')}}
                                        <a-icon type="down"/>
                                    </a-button>
                                </a-dropdown>
                            </a-col>
                        </a-row>
                    </div>

                    <z-column-check ref="columnCheck" :columnOption="columnOption"></z-column-check>
                    <div class="section-list">
                        <a-alert :showIcon="true" :message="tips" type="info"/>
                    </div>
                    <a-spin :spinning="isLoading" :tip="$t('global.loading')">
                        <a-table :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" 
                                :columns="columnOption.listColumns" :dataSource="data" :pagination="pagination" @change="onChange">
                            <template slot="delete" slot-scope="text,record">
                                <a-popconfirm
                                        v-if="data.length"
                                        :title="$t('global.confirm')"
                                        @confirm="onDelete(record)">
                                    <a>{{$t('global.delete')}}</a>
                                </a-popconfirm>
                                <a-divider type="vertical" />

                                <a-popconfirm
                                        v-if="record.sn"
                                        :title="$t('global.confirm')"
                                        @confirm="unbind(record)">
                                    <a>{{$t('global.unbind')}}</a>
                                </a-popconfirm>
                                <a v-else  @click="bind(record)">{{$t('global.bind')}}</a>
                                <a-divider type="vertical"/>
                                <a  @click="showTrack(record)">{{$t('global.track')}}</a>
                                <a-divider type="vertical"/>
                                <a  @click="askForLeave(record)">{{$t('global.absent')}}</a>
                                <a-divider type="vertical"/>
                                <a @click="showDetail(record)">{{$t('global.detail')}}</a>
                                <a-divider type="vertical"/>
                                <a @click="showUpdateModel(record)">{{$t('global.edit')}}</a>
                                <a-divider type="vertical"/>
                                <a @click="showPersonalConfigModal(record)">{{$t('global.option')}}</a>
                                <a-divider type="vertical"/>
                                <a @click="showPersonalFenceModal(record)">{{$t('global.fence')}}</a>
                                <!-- <a-dropdown>
                                    <a-menu slot="overlay">
                                        <a-menu-item key="1"  @click="showDetail(record)">详情</a-menu-item>
                                        <a-menu-item key="2"  @click="showUpdateModel(record)">修改</a-menu-item>
                                        <a-menu-item key="3"  @click="showPersonalConfigModal(record)">个人配置</a-menu-item>
                                        <a-menu-item key="4"  @click="showPersonalFenceModal(record)">个人围栏</a-menu-item>
                                    </a-menu>
                                    <a href="javascript:;">
                                        更多
                                        <a-icon type="down"/>
                                    </a>
                                </a-dropdown> -->
                            </template>
                            <template slot="date" slot-scope="text">
                                <span>{{text ? timeFormat(text) : ''}}</span>
                            </template>
                            <template slot="snExtra" slot-scope="text, record">
                              <span>{{text ? text + `${record.deviceType ? `(${record.deviceType})` : ''}` : ''}}</span>
                            </template>
                            <template slot="detailDate"  slot-scope="text">
                                <span>{{text ? moment(text * 1000).format('YYYY-MM-DD HH:mm:ss') : ''}}</span>
                            </template>
                            <template slot="image" slot-scope="text">
                                <!-- <img class="table-img" :src="text" preview="1"> -->
                                <PreViewImg :src="text" class="table-img" />
                            </template>
                            <template slot="absentStatus" slot-scope="text,record">
                                <div v-if="record.isAbsent">
                                    <a-tooltip>
                                        <template slot="title">
                                            <span style="width:300px">{{moment(record.start_time * 1000).format('YYYY/MM/DD HH:mm')  + '-' + moment(record.end_time * 1000).format('YYYY/MM/DD HH:mm')}}</span>
                                            <div style="width:300px">{{record.description}}</div>
                                        </template>
                                        <a-tag color="gray">{{$t('global.onAbsent')}}</a-tag>
                                    </a-tooltip>
                                </div>

                                <template v-else>
                                    <a-tag color="#2db7f5" v-if="!record.start_time">{{$t('global.noramlAbsent')}}</a-tag>
                                    <a-tooltip  v-else>
                                        <template slot="title">
                                            <span style="width:300px">{{moment(record.start_time * 1000).format('YYYY/MM/DD HH:mm')  + '-' + moment(record.end_time * 1000).format('YYYY/MM/DD HH:mm')}}</span>
                                            <div style="width:300px">{{record.description}}</div>
                                        </template>
                                        <a-tag color="#2db645">{{$t('global.preAbsent')}}</a-tag>
                                    </a-tooltip>
                                </template>

                            </template>
                        </a-table>
                    </a-spin>
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    // import FenceDrawer from '../../components/FenceDrawer/FenceDrawer'
    import config from '@/config'
    import ZSearchForm from '@/components/common/SearchForm.vue'
    import ZOrgChooser from '@/components/common/OrgChooser.vue'
    import ZColumnCheck from '@/components/common/ColumnCheck.vue'
    import ZAddEntity from '@/views/supervise/AddEntity.vue'
    import ZUploadEntity from '@/views/supervise/UploadEntity.vue'
    import ZUpdateGroup from '@/views/supervise/UpdateOrgGroup.vue'
    import ZEntityDetail from '@/views/supervise/EntityDetail.vue'
    import ZUpdateEntity from '@/views/supervise/UpdateEntity.vue'
    import ZDeviceBind from '@/views/supervise/DeviceBind.vue'
    import ZPersonalConfig from './PersonnalConfig'
    import ZPersonalConfigOf from './PersonnalConfigOf'
    import ZPersonalConfigAy from './PersonnalConfigAy'
    import ZPersonalConfigZ32S from './PersonalConfigZ32S'
    import ZPersonalFence from './PersonalFence'
    import ZPersonalTrack from './PersonalTrack'
    import ZAskLeave from './AskLeave'
    import PreViewImg from '../../components/common/PreViewImage'
    import {mapGetters} from 'vuex'
    import moment from 'moment'
    import {domScrollTop} from '../../utils/globalFunction'
    import {httpModel} from '../../http/httpModel'
    import bus from '../../bus/bus';
    import getGroupNames from '../../utils/formFunctions'

    export default {
        data() {
            return {
                // 是否显示请假的modal框
                showAskLeaveModal: false,
                // 请假的实体信息
                entityInfo: '',
                orgGroupsInfo: [],
                isLoading: false,
                data: [],
                orgOption:{
                    showDirect:true,
                    directFlag:false,
                    value: ""
                },
                org: null,
                groups:[],
                selectedRowKeys: [],
                selectedRows: [],
                searchParams: {},
                columnOption: {
                    listColumns: [],
                    columns: []
                },
                titles: [],
                columns:[
                    {
                        "title": 'deviceOrg',
                        "key": 'org',
                        "dataIndex": 'org',
                        "checkColumn": true
                    },
                    {
                        "title": 'group',
                        "key": 'group',
                        "dataIndex": 'group',
                        "checkColumn": true
                    },
                    {
                        "title": 'power',
                        "key": 'power',
                        "dataIndex": 'power',
                        "checkColumn": true
                    },
                    {
                        "title": 'lastOnlineTime',
                        "key": 'syncTimestamp',
                        "dataIndex": 'syncTimestamp',
                        "checkColumn": true,
                        "scopedSlots": {
                            "customRender": "detailDate"
                        },
                        "sorter": true
                    },
                    
                    {
                        "title": 'serialNumber',
                        "key": 'sn',
                        "dataIndex": 'sn',
                        "checkColumn": true,
                        "scopedSlots": {
                            "customRender": "snExtra"
                        }
                    },
                    {
                        "title": 'joinGroupTime',
                        "key": 'alterGroupTimestamp',
                        "dataIndex": 'alterGroupTimestamp',
                        "checkColumn": true,
                        "scopedSlots": {
                            "customRender": "date"
                        }
                    },
                    {
                        "title": 'absent',
                        "key": 'absentStatus',
                        "dataIndex": 'isAbsent',
                        "checkColumn": true,
                        "scopedSlots": {
                            "customRender": "absentStatus"
                        }
                    }
                ],
                searchOption: [
                  {
                    key: 'dimMatch',
                    name: '模糊查询',
                    type: 'input',
                    matchValue: 'li',
                    placeholder: '设备号/序列号',
                    option: {
                      showDirect: true,
                      allowClear: true,
                    }
                  },
                  {
                    key: "groupCategory",
                    name: "分组",
                    type: "selector",
                    placeholder: '请选择分组',
                    value: undefined,
                    source: []
                  },
                ],
                pagination:{
                    showSizeChanger: false,
                    pageSizeOptions:['2','10','50','100'],
                    pageSize: 10,
                    current: 1,
                    total : 0,
                    showTotal:this.showTotal,
                    showQuickJumper:true
                }
            }
        },
        components: {
            ZAskLeave,
            // FenceDrawer,
            ZOrgChooser,
            ZColumnCheck,
            ZSearchForm,
            ZAddEntity,
            ZUploadEntity,
            ZUpdateGroup,
            ZEntityDetail,
            ZUpdateEntity,
            ZDeviceBind,
            ZPersonalConfig,
            ZPersonalFence,
            ZPersonalTrack,
            PreViewImg,
            ZPersonalConfigOf,
            ZPersonalConfigAy,
            ZPersonalConfigZ32S
        },
        computed: {
            tips() {
                return this.$t('global.selectedNum', {num: this.selectedRowKeys.length})
            },
            ...mapGetters([
                'isSuperAdmin',
                'roles',
                'token'
            ])
        },
        methods:{ 
            moment,
            // 按分组筛选实体
            filterByGroup () {
              console.log(this.data)
            },
            // 关闭请假的modal框
            closeAskLeaveModal () {
                this.entityInfo = ''
                this.showAskLeaveModal = false
            },
            // 请假
            askForLeave (record) {
                // console.log(record)
                this.entityInfo = record
                this.showAskLeaveModal = true
            },
            // 结束请假
            cancerLeave (record) {
                console.log(record)
            },
            showTrack(record) {
                this.$refs['personalTrackModal'].showModal(record)
            },
            showUpdateModel(record){
                this.$refs["updateEntityModel"].showModel(record)
            },
            showPersonalConfigModal (record) {
             console.log("showPersonalConfigModal",record)
                if(record.oui == 'OF'){
                    this.$refs['personalConfigOfModal'].showModal(record)
                } else if(record.oui == 'AY'){
                    this.$refs['personalConfigAyModal'].showModal(record)
                }  else if(record.deviceType == 'Z32S'){
                    this.$refs['personalConfigZ32SModal'].showModal(record)
                } else {
                    this.$refs['personalConfigModal'].showModal(record)
                }
               
            }, 
            showPersonalFenceModal (record) {
              domScrollTop()
              this.$refs['personalFenceModal'].showModal(record)   
            },
            showDetail(record){
                this.$refs["entityDetailModel"].showModel(record.id)
            },
            bind(record){
                this.$refs["deviceBindModel"].showModel(record)
            },
            unbind(record){
                this.$http.get(config.api.entity_unbind_url + "/" + record.deviceId).then((response) => {
                    if(response.code == 0){
                        this.$message.success(this.$t('global.commitSuccess'))
                        this.pageQueryEntity()
                    } else {
                        this.$message.error(response.desc)
                    }
                })
            },
            handleMenuClick(e) {
                console.log('click', e);
            },
            batchDelete(){
                let _this = this
                this.$confirm({
                    title: _this.$t('global.confirm'),
                    onOk() {
                        _this.$http.post(config.api.entity_delete_url,_this.selectedRowKeys).then((response) => {
                            // console.log(response)
                            if(response.code == 0){
                                _this.$message.success(_this.$t('global.commitSuccess'))
                                _this.pageQueryEntity()
                            } else {
                                _this.$message.error(response.desc)
                            }
                        })
                        _this.selectedRowKeys = []
                    },
                    onCancel() {}
                });
            },
            batchUpdateGroup(){
                this.$refs["updateGroupModel"].showModel(this.groups,this.org,this.selectedRowKeys)
                //this.selectedRowKeys = []
            },
            showUploadEntity(){
                this.$refs["uploadEntityModel"].showModel()
            },
            showAddEntity(){
                this.$refs["addEntityModel"].showModel()
            },
            onDelete(entity){
                this.$http.delete(config.api.entity_url + "/" + entity.id).then((response) => {
                    console.log(response)
                    if(response.code == 0){
                        this.$message.success(this.$t('global.commitSuccess'))
                        this.pageQueryEntity()
                    } else {
                        this.$message.error(response.desc)
                    }
                })
            },
            handleSearch(params){
                this.searchParams = params
                this.pagination.current = 1
                this.selectedRowKeys = []
                this.pageQueryEntity()
            },
            showTotal(total) {
                return this.$t('global.totalRecords', {num: total})
            },
            timeFormat(timestamp) {
                return moment(timestamp * 1000).format('YYYY-MM-DD')
            },
            onSelectChange(selectedRowKeys,selectedRows) {
                this.selectedRowKeys = selectedRowKeys
                this.selectedRows = selectedRows
            },
            onTemplateUpdateSuccess(){
                this.onOrgSelect(this.org)
            },
            queryGroups(){
                let _this = this
                this.$http.get(config.api.entity_group_statistic_url + "/" + this.org.id + '/onlySelf/' + this.orgOption.directFlag).then((response) => {
                    if(response.code == 0){
                        this.groups = response.result
                        this.groups.map(function(item){
                            item.groupName = _this.getGroupNames(item.groupName)
                        })
                    }
                })
            },
            queryEntityTitles(){
                let _this = this
                this.$http.get(config.api.entity_title_url + "/" + this.org.id).then((response) => {
                    if(response.code == 0){
                        // console.log(response)
                        _this.columnOption.columns = []
                        _this.titles = response.result
                        response.result.map(function(item) {
                            if(item.isCrucial){
                                let column = {
                                    "title": _this.$t(`columnCheck.${item.name}`),
                                    "key": item.name,
                                    "dataIndex": item.name,
                                    "unConvert": true,
                                    "left": true
                                }
                                if(item.sortable){
                                    column.sorter = true
                                }
                                _this.columnOption.columns.push(column)
                            }
                        })
                        this.columns.map(function(item){ 
                            _this.columnOption.columns.push(item)
                        })
                        // _this.searchOption = []
                        response.result.map(function(item){
                            if(!item.isCrucial){
                                // if(item.isShow){
                                    let column = {
                                        "title": _this.$t(`columnCheck.${item.name}`),
                                        "key": item.name,
                                        "dataIndex": item.name,
                                        // "checkColumn": true
                                        "checkColumn": item.isShow ? true : false,
                                        "unConvert": true,
                                    }
                                    if(item.inputType == 'date'){
                                        column.scopedSlots = {
                                            "customRender": "date"
                                        }
                                    }
                                    if(item.inputType == 'image'){
                                        column.scopedSlots = {
                                            "customRender": "image"
                                        }
                                    }
                                    if(item.sortable){
                                        column.sorter = true
                                    }
                                    _this.columnOption.columns.push(column)
                                // }
                            }
                            if(item.searchable){
                                if(item.searchType == 'like'){
                                    _this.searchOption.push({
                                        key: item.name,
                                        name: item.name,
                                        type: "input",
                                        matchValue: "li",
                                        value: "",
                                        placeholder: item.name
                                    })
                                }else if(item.searchType == 'selectBox'){
                                    let sources = []
                                    item.dataSource.split(',').map(function(item){
                                        sources.push({name:item,value:item})
                                    })
                                    _this.searchOption.push({
                                        key: item.name,
                                        name: item.name,
                                        type: "selector",
                                        matchValue: "eq",
                                        source: sources,
                                        value: ""
                                    })
                                }else if(item.searchType == 'compare'){
                                    if(item.inputType == 'number'){
                                        _this.searchOption.push(
                                            {
                                                key: item.name,
                                                name: item.name,
                                                type : "custom",
                                                matchValue: "",
                                                searchTypeData :[
                                                    {
                                                        key: "大于",
                                                        type: "input",
                                                        paramName: 'min' + item.name,
                                                        value: null
                                                    },
                                                    {
                                                        key: "小于",
                                                        type: "input",
                                                        paramName: "max" + item.name,
                                                        value: null
                                                    },
                                                    {
                                                        key: "之间",
                                                        type: "inputRange",
                                                        paramName: 'min' + item.name + ',max' + item.name,
                                                        value: []
                                                    }
                                                ]
                                            },
                                        )
                                    }
                                    if(item.inputType == 'date'){
                                        _this.searchOption.push(
                                            {
                                                key: item.name,
                                                name: item.name,
                                                type : "custom",
                                                matchValue: "",
                                                dataType: "time",
                                                searchTypeData :[
                                                    {
                                                        key: "大于",
                                                        type: "datePicker",
                                                        paramName: 'min' + item.name,
                                                        value: null
                                                    },
                                                    {
                                                        key: "小于",
                                                        type: "datePicker",
                                                        paramName: "max" + item.name,
                                                        value: null
                                                    },
                                                    {
                                                        key: "之间",
                                                        type: "rangePicker",
                                                        paramName: 'min' + item.name + ',max' + item.name,
                                                        value: []
                                                    }
                                                ]
                                            }
                                        )
                                    }
                                }
                            }
                        })
                        _this.columnOption.columns.push(
                            {
                                "title": "operate",
                                "dataIndex": "operation",
                                "key": "operation",
                                "scopedSlots": {
                                    "customRender": "delete"
                                },
                                "right": true
                            }
                        )
                        this.$refs["columnCheck"].init()
                        // this.$previewRefresh()
                    }
                })
            },
            pageQueryEntity(){
                let _this = this
                this.isLoading = true
                this.searchParams["pageSize"] = this.pagination.pageSize.toString()
                this.searchParams["currentPage"] = this.pagination.current.toString()
                if(this.orgOption.directFlag){
                    this.searchParams["matchType"] = 'eq'
                }else{
                    this.searchParams["matchType"] = 'll'
                }
                // console.log(this.searchParams)
                this.$http.post(config.api.entity_all_url + "/" + this.org.id,this.searchParams).then((response) => {
                    if(response.code == 0){
                        this.data = response.result.resultList
                        // console.log(this.data)
                        this.data.map(function(item){
                            item.key = item.id
                            item.group = _this.getGroupNames(item.group)
                        })
                        this.pagination.total = response.result.page.totalSize
                        this.pagination.current = response.result.page.currentPage
                    }
                    this.isLoading = false
                })
            },
            queryGroupsInfo () {
              httpModel.getOrgGroupsInfo(this.org.id).then((res) => {
                // console.log(res)
                this.orgGroupsInfo = res
                this.searchOption.find((option) => option.key === 'groupCategory').source = this.orgGroupsInfo.map((group) => {
                  return {
                    name:  this.getGroupNames(group.groupName),
                    value: group.category
                  }
                })
              })
            },
            onOrgSelect(org){
                this.org = org
                delete this.searchParams["orderBy"]
                delete this.searchParams["sort"]
                this.queryGroups();
                this.queryGroupsInfo()
                if(this.columnOption.columns.length == 0){
                    this.queryEntityTitles()
                }
                this.selectedRowKeys = []
                this.pagination.current = 1
                this.pageQueryEntity()
            },
            onDirectChange(){
                this.pagination.current = 1
                this.selectedRowKeys = []
                this.queryGroups()
                this.queryGroupsInfo()
                this.pageQueryEntity()
            },
            onChange(page, filters, sorter){
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                if(sorter.order){
                    this.searchParams['orderBy'] = sorter.field
                    if(sorter.order == "ascend"){
                        this.searchParams['sort'] = "ASC"
                    }else{
                        this.searchParams['sort'] = "DESC"
                    }
                }else{
                    delete this.searchParams["orderBy"]
                    delete this.searchParams["sort"]
                }
                this.pageQueryEntity()
            },
            refreshTable(){
                this.selectedRowKeys = []
                this.queryGroups()
                this.queryGroupsInfo()
                this.pageQueryEntity()
            },
           
            getGroupNames(groupName){
                switch(groupName){
                    case '普管组':
                    case '宽管组':
                    case '严管组':
                    return this.$t(`global.${groupName}`)
                    default:
                    return groupName
                }
}
        },
        mounted () {
          bus.$on('langChanged', (lang) => {
            // console.log(lang)
            this.$nextTick().then(() => {
              this.$refs["columnCheck"].refresh()
            })
          })
        },
        beforeDestroy () {
          bus.$off('langChanged')
        },
    }
</script>
<style lang="less" scoped>
.table-img {
    // width: 20px;
    max-height: 17px;
    cursor: pointer;
}
.icon-custom {
  font-size: 2rem;
}
.avatar-icon {
  // background-color: rgba(151, 152, 153, 0.288);
  // box-shadow: .1px 0 1px #333;
  padding: 0 5px;
}
</style>
